import React from "react";
import { Phone, ArrowRight, ShieldCheck, Clock, MapPin } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/5851fc73-f9fd-482d-a31a-8b088a0ed559/images/d5b861278d2def1caaac2eace32305557d94e8621c76caa3c858a47081eb7efb.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate min-h-[92vh] flex items-end overflow-hidden bg-[#001a33]"
    >
      <img
        src={HERO_IMG}
        alt="Toiture-terrasse moderne étanchéifiée par ETANCIA"
        className="absolute inset-0 w-full h-full object-cover object-center opacity-80"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-[#001a33]/80 via-[#003366]/55 to-transparent" />
      <div className="absolute inset-0 diag-lines opacity-30" />

      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-16 md:pb-20 grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8 text-white">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-block w-10 h-px bg-[#FF5A1F]" />
            <span className="label-kicker text-[#FF5A1F]">
              Étanchéité Île-de-France
            </span>
          </div>
          <h1
            data-testid="hero-title"
            className="font-display font-extrabold leading-[0.95] text-5xl md:text-7xl lg:text-[5.5rem] tracking-tight"
          >
            L'étanchéité <br />
            <span className="text-[#FF5A1F]">qui tient,</span>
            <br /> sans compromis.
          </h1>
          <p className="mt-6 max-w-xl text-base md:text-lg text-slate-200/90 leading-relaxed">
            ETANCIA réalise vos gros travaux et interventions rapides sur
            toitures-terrasses, accessibles comme inaccessibles. Expertise,
            réactivité, garantie.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-3">
            <a
              href="#contact"
              data-testid="hero-cta-devis"
              className="group inline-flex items-center gap-2 bg-[#FF5A1F] hover:bg-[#E04812] text-white text-sm font-semibold px-7 py-4 transition-all hover:-translate-y-0.5 shadow-md"
            >
              Demander un devis gratuit
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="tel:0658116161"
              data-testid="hero-cta-call"
              className="inline-flex items-center gap-2 border-2 border-white/70 hover:border-white text-white text-sm font-semibold px-6 py-4 bg-white/5 hover:bg-white/10 backdrop-blur transition-all"
            >
              <Phone className="w-4 h-4" />
              Intervention rapide : 06 58 11 61 61
            </a>
          </div>
        </div>

        <div className="lg:col-span-4 grid grid-cols-3 lg:grid-cols-1 gap-0 border border-white/20 bg-white/5 backdrop-blur-md">
          {[
            { icon: Clock, k: "24h", v: "Intervention rapide" },
            { icon: ShieldCheck, k: "10 ans", v: "Garantie décennale" },
            { icon: MapPin, k: "IDF", v: "& alentours" },
          ].map((s, i) => (
            <div
              key={i}
              className={`p-5 lg:p-6 text-white ${
                i !== 2 ? "lg:border-b border-r lg:border-r-0 border-white/20" : ""
              }`}
            >
              <s.icon className="w-5 h-5 text-[#FF5A1F] mb-2" />
              <div className="font-display text-2xl md:text-3xl font-bold leading-none">
                {s.k}
              </div>
              <div className="text-xs uppercase tracking-wider text-slate-200/80 mt-2">
                {s.v}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
